"use client";

import { env } from "@/env";
import type { Lang } from "@/langs";
import { authClient } from "@borderless/auth/client";
import { Button } from "@borderless/ui/components/button";
import { tGlob } from "../_t-glob/t-glob";

export function GoToAppButton(props: {
  size?: "sm" | "default";
  lang: Lang;
  className?: string;
}) {
  const { size = "default" } = props;
  const { data } = authClient.useSession();

  return (
    <Button asChild size={size} className={props.className}>
      <a href={env.NEXT_PUBLIC_WORKSPACE_BASE_URL}>
        {data
          ? tGlob("Go to App", props.lang)
          : tGlob("Get Started - *it's free!*", props.lang)}
      </a>
    </Button>
  );
}
